export declare type DeviceType = "MOBILE" | "TABLET" | "DESKTOP" | "SERVER" | "UNKNOWN";

export const isDeviceType = (value: string): value is DeviceType => {
	return value === "MOBILE" || value === "TABLET" || value === "DESKTOP" || value === "SERVER";
};

export const getDeviceType = (userAgent: string): DeviceType => {

	const isBrowser = typeof window !== "undefined" && typeof navigator !== "undefined" && typeof document !== "undefined";
	if(isBrowser) {
		const result = (
			/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent) ? "MOBILE" :
			/iPad|Tablet|PlayBook|Kindle|Silk/i.test(userAgent) ? "TABLET" :
			/Mac|Windows|Linux|Chrome|Firefox|Safari/i.test(userAgent) ? "DESKTOP" :
			"UNKNOWN"
		)
		if(result === "UNKNOWN") {
			console.warn("Unknown device type in user agent:", userAgent);
		}
		return result;
	}
	
	return "SERVER";
	
};
